export default __webpack_public_path__ + "static/media/route_optimize.6489743e.svg";